module.exports = __webpack_public_path__ + "assets/img/new_banner2.b69b9141.jpg";